import { PLFlag, GBFlag, DEFlag } from 'mantine-flagpack';
import { pl, enGB, de } from 'date-fns/locale';

const LANGUAGES = {
	PL: {
		name: 'languages.pl',
		code: 'pl',
		displayCode: 'PL',
		flag: PLFlag,
		dateFnsLocale: pl,
	},
	EN: {
		name: 'languages.en',
		code: 'en',
		displayCode: 'EN',
		flag: GBFlag,
		dateFnsLocale: enGB,
	},
	DE: {
		name: 'languages.de',
		code: 'de',
		displayCode: 'DE',
		flag: DEFlag,
		dateFnsLocale: de,
	},
} as const;

export default LANGUAGES;
